import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { ExtractionListData } from './extraction-list.types';
import { useGlobalStore } from '@old/global-store/use-store';
import { transformIntoQueryParamString } from '@old/utils/service';

// implementado ✅
// deprecated service ref.: getSilobagExtraction_DEPRECATED
export async function extractionListService() {
  const { organizationId } = useGlobalStore.getState();
  const query = transformIntoQueryParamString({ organization_id: organizationId });
  const { response, data } = await BACKEND.get<ExtractionListData>(ENDPOINT.SILOBAG_EXTRACTION, { query });

  return {
    response,
    summary: data,
  };
}
